import * as React from 'react';

import { AnimationElement } from '../common/Animation';

import { AreaPartsContainer } from './components/AreaParts';
import { MultiPostingContainer } from './components/MultiPosting';
import { Layout } from '../ServicePickerWidget/Layout';

export const MessageWrapper = () => {
  return (
    <div data-testid="messages">
      <AnimationElement layout>
        <AnimationElement layout="position">
          <Layout>
            <AreaPartsContainer />
            <MultiPostingContainer />
          </Layout>
        </AnimationElement>
      </AnimationElement>
    </div>
  );
};
